module.exports = __webpack_public_path__ + "static/media/slider-menu.9f4db329.png";